import { Button, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { confirmDialogState } from 'state';

export function DeleteConfirmDialog() {
  const { t } = useTranslation();
  const [dialogState, setDialogState] = useRecoilState(confirmDialogState);
  return (
    <>
      <DialogTitle data-testid="delete-confirm-dialog-title">
        {t('dialogs.deleteConfirm.title')}
      </DialogTitle>

      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            setDialogState({
              isOpen: false,
            });
          }}
          color="secondary"
        >
          {t('general.no')}
        </Button>
        <Button
          data-testid="delete-confirm-dialog-yes"
          variant="contained"
          onClick={() => {
            const action = dialogState.action;
            if (action) {
              action();
            }

            setDialogState({
              isOpen: false,
            });
          }}
        >
          {t('general.yes')}
        </Button>
      </DialogActions>
    </>
  );
}
